import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const escalationListSearchSchema = z.object({
  search: z.coerce.string().optional().catch(""),
  // Default to "needs setup" so the landing surfaces facilities that need work;
  // "all" clears the filter.
  status: z
    .enum(["all", "not_set_up", "not_signed_off", "signed_off"])
    .catch("not_set_up"),
  page: z.coerce.number().catch(1),
})

export const Route = createFileRoute("/_app/oncology/escalation/")({
  validateSearch: (search: SearchSchemaInput) =>
    escalationListSearchSchema.parse(search),
})
